export enum ApprovalType {
  TFA = 'TFA',
  SIGN_ON_GLASS = 'SIGN_ON_GLASS',
  OWN = 'OWN',
  SIGNING_CODE = 'SIGNING_CODE',
}
